export default __webpack_public_path__ + "static/media/expedia_logo.b441d75e.svg";